import { action, thunk } from 'easy-peasy'
import {
  dependencyContextMapper,
  errorMapper,
  requestMapper,
  responseMapper,
  sendLogHitEndpoint,
} from 'lib/datadog/log'
import objectToCamelCase from 'lib/transform/object-to-camel-case'
import sellerEvent from 'services/Seller/events'
import ISellerSummaryModel from 'services/Seller/models/ReportModel/SellerSummaryModel/interface'

const SellerSummaryModel: ISellerSummaryModel = {
  isLoading: false,
  isError: false,
  data: null,
  setIsLoading: action((state, payload) => {
    state.isLoading = payload
  }),
  setIsError: action((state, payload) => {
    state.isError = payload
  }),
  setData: action((state, payload) => {
    state.data = payload
  }),
  getSummary: thunk(async (actions, payload, { injections }) => {
    actions.setIsLoading(true)
    actions.setIsError(false)
    try {
      const { apiClient } = injections
      const res = await apiClient({
        url: `/seller/v2/seller-summary?start_date=${payload.startDate}&end_date=${payload.endDate}`,
        method: 'GET',
      })
      actions.setData(objectToCamelCase(res.data))
      sendLogHitEndpoint(
        sellerEvent.getSummary.event,
        dependencyContextMapper(
          sellerEvent.getOperationalStore.dependency,
          requestMapper(res.config),
          responseMapper(res),
        ),
      )
    } catch (err) {
      actions.setIsError(true)
      sendLogHitEndpoint(
        sellerEvent.getSummary.event,
        dependencyContextMapper(
          sellerEvent.getSummary.dependency,
          requestMapper(err.config),
          errorMapper(err),
        ),
      )
    } finally {
      actions.setIsLoading(false)
    }
  }),
}

export default SellerSummaryModel
